import React from 'react';
import './CheckboxGroup.scss';

const CheckboxGroup = ({ 
  id, 
  label, 
  options, 
  name, 
  selectedValue, 
  onChange 
}) => {
  const handleCheckboxChange = (value) => {
    // If clicking the currently selected value, clear it
    // Otherwise set the new value
    const newValue = selectedValue === value ? '' : value;
    onChange({ target: { name, value: newValue } });
  };

  return (
    <li className="form-line" data-type="control_checkbox" id={id}>
      <label className="form-label form-label-top form-label-auto" id={`label_${id}`} aria-hidden="false">
        {label}
      </label>
      <div id={`cid_${id}`}  data-layout="full">
        <div className="form-single-column" role="group" aria-labelledby={`label_${id}`} data-component="checkbox">
          {options.map((option, index) => (
            <span key={`${id}_${index}`}  style={{ clear: 'left' }}>
              <span className="dragger-item"></span>
              <input
                aria-describedby={`label_${id}`}
                type="checkbox"
                className="form-checkbox validate[maxselection]"
                id={`input_${id}_${index}`}
                name={`${name}[]`}
                data-maxselection="1"
                value={option.value}
                checked={selectedValue === option.value}
                onChange={() => handleCheckboxChange(option.value)}
              />
              <label id={`label_input_${id}_${index}`} htmlFor={`input_${id}_${index}`}>
                {option.label}
              </label>
            </span>
          ))}
        </div>
      </div>
    </li>
  );
};

export default CheckboxGroup; 